module.exports = new __parcel__URL__("disclaimer_image.420276c7.png").toString();